import { NgModule } from '@angular/core';
import { PermissionService } from './permission.service';
import { PermissionBackend } from './permission.backend';

@NgModule({
  providers: [PermissionService, PermissionBackend],
})
export class PermissionModule {}
